import Cookie from './Cookie';

export const ACCESS_TOKEN_COOKIE_NAME = 'mindsets_access_token_';

export default class Auth {
    isAuthenticated() {
        const accessToken = this.getAccessToken();
        return null !== accessToken && '' !== accessToken;
    }

    /**
     * @deprecated Do not use
     * @param access_token
     * @param expires_in
     */
    handleAuthorization(access_token, expires_in) {
        if (!expires_in) {
            expires_in = 86400;
        }
        Cookie.setCookie(ACCESS_TOKEN_COOKIE_NAME + process.env.PUBLIC_APP_SOURCE + '_' + process.env.PUBLIC_APP_ENV, access_token, expires_in);
    }

    logout() {
        Cookie.eraseCookie(ACCESS_TOKEN_COOKIE_NAME + process.env.PUBLIC_APP_SOURCE + '_' + process.env.PUBLIC_APP_ENV);
    }

    getAccessToken() {
        return Cookie.getCookie(ACCESS_TOKEN_COOKIE_NAME + process.env.PUBLIC_APP_SOURCE + '_' + process.env.PUBLIC_APP_ENV);
    }
}
